import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { CheckCircle, UploadFileOutlined } from '@mui/icons-material';
import { BASE_URL } from '../constants';
import { LoadingSection } from '../LoadingSection';
import { useDataProvider, useNotify, useRecordContext, useRefresh } from 'react-admin';
import { useMutation, useQuery } from 'react-query';
import { goApi } from '../../services';

export const uploadFile = (questions: any, images: any, path: any) => {
    const formData = new FormData();
    formData.append('questions', questions);
    formData.append('images', images);

    //TODO: remove access to this
    return fetch(BASE_URL + '/questions/upload-questions', {
        method: 'POST',
        body: formData,
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
    });
};

const BulkQuestionsInput = (props: any = {}) => {
    const [loading, setLoading] = useState(false);
    const [questionsFile, setQuestionsFile] = useState(null as any);
    const [imagesFile, setImagesFile] = useState(null as any);
    const record = useRecordContext();
    const dataProvider = useDataProvider();
    const [sectionIds, setSectionIds] = useState<string[]>([]);
    const refresh = useRefresh();
    const notify = useNotify();
    const sectionQueryEnabled = props?.path === '/test';

    const { data: Sections } = useQuery(
        ['sections', 'getList', record?.id],
        () =>
            dataProvider.getList('sections', {
                filter: { test_id: record?.id },
                pagination: { page: 1, perPage: 100 },
                sort: { field: 'id', order: 'ASC' },
            }),
        {
            enabled: sectionQueryEnabled,
        },
    );

    useEffect(() => {
        if (Sections?.data?.length) {
            const ids = Sections.data.map((section: any) => section.id);
            setSectionIds(ids);
        }
    }, [Sections]);

    const createSectionMutation = useMutation(
        (newSectionData: any) => dataProvider.create('sections', { data: newSectionData }),
        {
            onError: error => {
                console.error('Section creation error:', error);
                alert('Failed to create section. Check console for details.');
            },
        },
    );
    return (
        <>
            <div style={{ position: 'relative', width: '500px' }}>
                {loading ? (
                    <LoadingSection />
                ) : (
                    <>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {imagesFile ? (
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginBottom: '15px',
                                    }}
                                >
                                    <CheckCircle style={{ color: 'green' }} /> Images Uploaded
                                </div>
                            ) : (
                                <Button>
                                    Add Image File
                                    <input
                                        placeholder={props.placeholder}
                                        style={{
                                            position: 'absolute',
                                            left: '0',
                                            right: '0',
                                            bottom: '0',
                                            top: '0',
                                            opacity: '0',
                                        }}
                                        accept="application/zip"
                                        multiple={false}
                                        value={''}
                                        onChange={async e => {
                                            const file = e.target.files?.[0];
                                            setImagesFile(file);
                                        }}
                                        type={'file'}
                                    />
                                </Button>
                            )}
                        </div>

                        <div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {questionsFile ? (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '15px',
                                        }}
                                    >
                                        <UploadFileOutlined />
                                        <Button
                                            onClick={async () => {
                                                setLoading(true);
                                                try {
                                                    const res = await uploadFile(
                                                        questionsFile,
                                                        imagesFile,
                                                        props?.path,
                                                    );

                                                    if (
                                                        res?.status !== 200 &&
                                                        res?.status !== 201
                                                    ) {
                                                        alert(
                                                            'Unable to upload questions, check console for error',
                                                        );
                                                        setLoading(false);
                                                        return;
                                                    }

                                                    const result = await res.json();
                                                    const token = localStorage.getItem('token');

                                                    if (!token) {
                                                        alert('Missing auth token');
                                                        setLoading(false);
                                                        return;
                                                    }

                                                    if (
                                                        (props?.path === '/test' ||
                                                            props?.path === '/sections') &&
                                                        Array.isArray(result?.dbQuestions)
                                                    ) {
                                                        if (
                                                            props?.path === '/test' &&
                                                            result.dbQuestions.length > 0
                                                        ) {
                                                            let finalSectionId: string | null =
                                                                null;
                                                            const missingSectionQuestions: any[] =
                                                                [];
                                                            const invalidSectionIdsSet =
                                                                new Set<string>();
                                                            result.dbQuestions.forEach((q: any) => {
                                                                if (!q.section_id) {
                                                                    missingSectionQuestions.push(q);
                                                                } else if (
                                                                    !sectionIds.includes(
                                                                        q.section_id,
                                                                    )
                                                                ) {
                                                                    invalidSectionIdsSet.add(
                                                                        q.section_id,
                                                                    );
                                                                }
                                                            });

                                                            if (invalidSectionIdsSet.size > 0) {
                                                                alert(
                                                                    `Error: Invalid section_id(s) found: ${Array.from(
                                                                        invalidSectionIdsSet,
                                                                    ).join(', ')}`,
                                                                );
                                                                setLoading(false);
                                                                return;
                                                            }

                                                            if (
                                                                missingSectionQuestions.length > 0
                                                            ) {
                                                                try {
                                                                    const nextSectionNumber =
                                                                        sectionIds.length + 1;
                                                                    const newSection =
                                                                        await createSectionMutation.mutateAsync(
                                                                            {
                                                                                name: `Section ${nextSectionNumber}`,
                                                                                testId: record?.id,
                                                                                displayOrder:
                                                                                    sectionIds.length,
                                                                            },
                                                                        );

                                                                    const newSectionId =
                                                                        newSection?.data?.id;
                                                                    if (!newSectionId) {
                                                                        throw new Error(
                                                                            'Section creation succeeded but no ID returned.',
                                                                        );
                                                                    }

                                                                    finalSectionId = newSectionId;

                                                                    missingSectionQuestions.forEach(
                                                                        (q: any) => {
                                                                            q.section_id =
                                                                                finalSectionId;
                                                                        },
                                                                    );

                                                                    setSectionIds((prev: any) => [
                                                                        ...prev,
                                                                        finalSectionId,
                                                                    ]);
                                                                } catch (err) {
                                                                    console.error(
                                                                        'Section creation failed:',
                                                                        err,
                                                                    );
                                                                    alert(
                                                                        'Failed to create section. Check console for details.',
                                                                    );
                                                                    setLoading(false);
                                                                    return;
                                                                }
                                                            }
                                                        }

                                                        const data = {
                                                            questions: result.dbQuestions.map(
                                                                ({
                                                                    id,
                                                                    displayOrder,
                                                                    positiveMarks,
                                                                    negativeMarks,
                                                                    sectionId,
                                                                }: any) => ({
                                                                    id,
                                                                    displayOrder: Number(
                                                                        displayOrder ?? 0,
                                                                    ),
                                                                    positiveMarks:
                                                                        positiveMarks ?? 0,
                                                                    negativeMarks:
                                                                        negativeMarks ?? 0,
                                                                    sectionId:
                                                                        sectionId ?? record?.id,
                                                                }),
                                                            ),
                                                        };
                                                        const testId =
                                                            props?.path === '/test'
                                                                ? record?.id
                                                                : record?.test_id;

                                                        const sendData = await goApi.post(
                                                            `/sections-question-mappings/${testId}/bulk`,
                                                            data,
                                                        );
                                                        refresh();
                                                        notify('Question Added successfully', {
                                                            type: 'success',
                                                        });
                                                        if (!sendData) {
                                                            throw new Error(
                                                                'Bulk section question API failed',
                                                            );
                                                        }
                                                    }
                                                } catch (error) {
                                                    console.error(error);
                                                    alert(
                                                        'Unable to upload questions, check console for error',
                                                    );
                                                } finally {
                                                    props.onSuccess?.();
                                                    setLoading(false);
                                                }
                                            }}
                                        >
                                            Upload Excel File
                                        </Button>
                                    </div>
                                ) : (
                                    <Button disabled={loading || !imagesFile}>
                                        Add Excel file
                                        <input
                                            accept={'.xlsx,.xls'}
                                            placeholder={props.placeholder}
                                            style={{
                                                position: 'absolute',
                                                left: '0',
                                                right: '0',
                                                bottom: '0',
                                                top: '0',
                                                opacity: '0',
                                            }}
                                            multiple={false}
                                            value={''}
                                            onChange={async e => {
                                                const file = e.target.files?.[0];
                                                setQuestionsFile(file);
                                            }}
                                            type={'file'}
                                        />
                                    </Button>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default BulkQuestionsInput;
